module.exports = __webpack_public_path__ + "static/img/3333.5ff5740.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/3333.jpg
// module id = 8B68
// module chunks = 1